<ion-header>
  <ion-toolbar>
    <div class="selectFoodHeading">
      <ion-title>{{ 'library.supplementSelect.title' | translate }}</ion-title>
    </div>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()" class="closeBtn">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid>
    <ion-row class="wp-filterMainPanel">
      <ion-col class="client-info">
        <div class="panel">
          <div class="panel-header">
            <ion-searchbar
              [(ngModel)]="filters.searchTerm"
              (ionInput)="filterChanged()"
              [placeholder]="'general.search' | translate">
            </ion-searchbar>
          </div>

          <div class="panel-body">
            <div class="foods-container">
              <div *ngIf="supplements">
                <div
                  class="food-item"
                  *ngFor="let supplement of filteredSupplements | slice:0:maxLimit"
                  [class.is-selected]="isSupplementSelected(supplement.id)"
                  (click)="toggleSupplement(supplement)">
                  <div class="title">
                    <h3>{{ supplement.title }}</h3>
                    <p class="brand" *ngIf="supplement.brand">{{ supplement.brand }}</p>
                  </div>
                  <span class="select-check" aria-hidden="true">
                    <ion-icon name="checkmark" *ngIf="isSupplementSelected(supplement.id)"></ion-icon>
                  </span>
                </div>
              </div>

              <div class="empty-state" *ngIf="supplements && filteredSupplements?.length === 0">
                <p *ngIf="filters.searchTerm">{{ 'library.supplementSelect.noMatches' | translate:{ searchTerm: filters.searchTerm } }}</p>
                <p *ngIf="!filters.searchTerm">{{ 'library.supplementSelect.noSupplements' | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-infinite-scroll
    threshold="100px"
    (ionInfinite)="loadData($event)"
    [disabled]="!filteredSupplements || maxLimit >= filteredSupplements.length">
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      [loadingText]="'library.supplementSelect.loadingSupplements' | translate">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>

<ion-footer>
  <ion-toolbar class="selected-toolbar" *ngIf="selectedSupplements.length > 0">
    <div class="selected-chips">
      <ion-chip outline color="primary" *ngFor="let supplement of selectedSupplements" (click)="toggleSupplement(supplement)">
        <ion-label>{{ supplement.title }}</ion-label>
        <ion-icon name="close-circle"></ion-icon>
      </ion-chip>
    </div>
  </ion-toolbar>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="solid"
        color="secondary"
        (click)="done()"
        size="small"
        [disabled]="!selectedSupplements?.length">
        {{ 'library.supplementSelect.addSupplements' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
